import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiTarget } = FiIcons;

const SCHEDULE = [
  { time: '08:00 AM', title: 'School Drop-off', person: 'Dad', done: true },
  { time: '03:15 PM', title: 'Pick up Leo', person: 'Mom', done: false, highlight: true },
  { time: '04:30 PM', title: 'Pick up Mia', person: 'Dad', done: false },
  { time: '05:00 PM', title: 'Soccer Practice (Leo)', person: 'Mom', done: false },
];

export default function TimelineWidget() {
  return (
    <div className="bg-white rounded-3xl p-6 shadow-sm border border-slate-200">
      <h3 className="text-lg font-bold text-[#1a365d] mb-6 flex items-center gap-2">
        <SafeIcon icon={FiTarget} />
        Today's Flight Plan
      </h3>
      
      <div className="relative pl-4 space-y-6">
        {/* Vertical line connecting dots */}
        <div className="absolute left-[21px] top-2 bottom-2 w-px bg-slate-200"></div>
        
        {SCHEDULE.map((item, idx) => (
          <div key={idx} className="relative flex gap-4 items-start group">
            <div className={`
              z-10 w-4 h-4 rounded-full mt-1 border-2 bg-white flex-shrink-0 transition-colors
              ${item.done ? 'border-green-400 bg-green-400' : 
                item.highlight ? 'border-yellow-400' : 'border-slate-300'}
            `}></div>
            
            <div className={`flex-1 rounded-xl p-3 -mt-2 transition-all ${
              item.highlight ? 'bg-yellow-50 border border-yellow-200' : 'hover:bg-slate-50'
            }`}>
              <div className="flex justify-between items-start">
                <div>
                  <h4 className={`font-semibold text-sm ${item.done ? 'text-slate-400 line-through' : 'text-slate-800'}`}>
                    {item.title}
                  </h4>
                  <p className="text-xs text-slate-500 mt-0.5">{item.time}</p>
                </div>
                <span className="text-[10px] font-bold bg-[#1a365d]/10 text-[#1a365d] px-2 py-1 rounded-md">
                  {item.person}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}